// @flow

import type { BasicProps } from '../../type'

import * as React from 'react'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'
import { getVisitor } from '../../redux/basic'

type Props = BasicProps & {
  unLoginShow?: boolean,
  loginInvestShow?: boolean,
  loginNoInvestShow?: boolean,
  isShow?: boolean,
  visibleRule?: ?string,
  customProps?: any
};

type State = {
  isShow: boolean,
  visible: boolean
};

export default function (WrappedComponent: React.ComponentType<*>) {
  class Visibility extends React.PureComponent<Props, State> {
    wrappedComponent: ?React.Component<*>;

    static defaultProps = {
      isShow: true,
      unLoginShow: true,
      loginInvestShow: true,
      loginNoInvestShow: true
    };

    static actions = appendPropsActions(WrappedComponent, [
      {
        title: '显示',
        name: 'show'
      },
      {
        title: '隐藏',
        name: 'hide'
      },
      {
        title: '隐藏显示开关',
        name: 'toggle'
      }
    ]);

    static schema = appendPropsSchema(WrappedComponent, [
      'visibility',
      'hr',
      {
        title: '增加规则',
        key: 'visibleRule',
        type: 'code'
      },
      'hr',
      {
        type: 'event',
        title: '显示',
        event: 'show'
      },
      {
        type: 'event',
        title: '隐藏',
        event: 'hide'
      }
    ]);

    constructor (props: Props) {
      super(props)
      let { isShow } = Visibility.defaultProps
      this.state = {
        isShow: props.isShow != null ? props.isShow : isShow,
        visible: false
      }
    }

    componentDidUpdate (preProps: Props, preState: State) {
      if (this.props.isShow !== preProps.isShow) {
        this.setState({
          isShow: this.props.isShow
        })
      }
      const { callActions } = this.props
      if (this.state.visible !== preState.visible) {
        if (this.state.visible) {
          callActions('show')
        } else {
          callActions('hide')
        }
      }
    }

    componentDidMount () {
      const { callActions } = this.props
      if (this.state.visible) {
        callActions('show')
      } else {
        callActions('hide')
      }
    }

    checkShowCondition (props: Props) {
      const { unLoginShow, loginInvestShow, loginNoInvestShow } = props
      let { isLogin, investCount = 0 } = getVisitor() || {}
      if (isLogin) {
        // 登录投资不显示
        if (!loginInvestShow && investCount > 0) {
          return false
        }
        // 登录没投资不显示
        if (!loginNoInvestShow && !investCount) {
          return false
        }
      } else {
        // 没登录不显示
        if (!unLoginShow) {
          return false
        }
      }
      return true
    }

    actionShow = () => {
      this.setState({ isShow: true })
    };

    actionHide = () => {
      this.setState({ isShow: false })
    };

    actionToggle = () => {
      this.setState({ isShow: !this.state.isShow })
    };

    isVisible = (props: Props, state: State) => {
      const { visibleRule, jsEnv } = props
      let visible: boolean = this.checkShowCondition(props) && state.isShow
      if (visible && visibleRule) {
        visible = jsEnv.runCode(visibleRule)
      }
      return !!visible
    };

    componentWillUpdate (nextProps: Props, nextState: State) {
      this.setState({ visible: this.isVisible(nextProps, nextState) })
    }

    componentWillMount () {
      this.setState({ visible: this.isVisible(this.props, this.state) })
    }

    render () {
      const visible = this.state.visible
      return (
        <WrappedComponent
          ref={ref => {
            if (ref) {
              this.wrappedComponent = ref
            }
          }}
          visible={visible}
          {...this.props}
        />
      )
    }
  }

  return Visibility
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/visibility.js